import { Component, Inject } from '@angular/core';
import {
	LO_DIALOG_DATA,
	LoButton,
	LoDialog,
	LoDialogRef,
	LoStatus
} from 'lo-design-system';
import { PlanDetailsDialogData } from './plan-details-dialog.model';

/**
 * Everything one plan includes, grouped by the product that owns each row.
 *
 * THIS IS WHERE THE PLAN CARD'S OLD BODY WENT. The card used to print all 24
 * entitlements the catalogue carries — twelve of them numeric ceilings — which
 * answered "am I about to run out" on a surface whose only question is "which
 * one do I buy". The card now carries the four rows that settle that question
 * and links here for the rest; a brand that already holds the plan gets the same
 * list on the billing page with its real usage beside each number, which is
 * strictly more than this dialog can show.
 *
 * It renders what the card handed it and fetches nothing, so there is no loading
 * state to get wrong: the rows are built from the same `CatalogPlan` the card is
 * already displaying, for the rung its dial currently has selected.
 */
@Component({
	standalone: true,
	selector: 'app-plan-details-dialog',
	imports: [LoButton, LoDialog, LoStatus],
	template: `
		<lo-dialog [heading]="'Everything included in ' + data.planTitle">
			<div class="content">
				@if (data.rungLabel) {
				<p class="rung lo-type-text-md">{{ data.rungLabel }}</p>
				} @for (group of data.groups; track group.title) {
				<section class="group" data-testid="plan-details-group">
					<h3 class="lo-type-text-md-semibold">{{ group.title }}</h3>
					<dl class="rows lo-type-text-md">
						@for (row of group.rows; track row.label) {
						<div class="row">
							<dt>{{ row.label }}</dt>
							<dd>
								@if (row.value === 'On') {
								<lo-status
									tone="success"
									data-testid="plan-details-on"
								>
									On
								</lo-status>
								} @else if (row.value === 'Off') {
								<lo-status tone="neutral">Off</lo-status>
								} @else {
								<span class="lo-type-text-md-semibold">
									{{ row.value }}
								</span>
								}
							</dd>
						</div>
						}
					</dl>
				</section>
				}

				<p class="foot lo-type-text-sm">
					Usage against these allowances lives on the Billing page,
					next to the plan you hold.
				</p>
			</div>
			<div loDialogActions>
				<button lo-button type="button" (click)="close()">Done</button>
			</div>
		</lo-dialog>
	`,
	styles: [
		`
			.content {
				display: flex;
				flex-direction: column;
				gap: var(--lo-space-gap-lg);

				.rung,
				.foot {
					margin: 0;
					color: var(--lo-color-text-secondary);
				}

				.group {
					display: flex;
					flex-direction: column;
					gap: var(--lo-space-gap-sm);

					h3 {
						margin: 0;
					}

					.rows {
						display: flex;
						flex-direction: column;
						margin: 0;

						.row {
							display: flex;
							align-items: center;
							justify-content: space-between;
							gap: var(--lo-space-gap-md);
							padding: var(--lo-space-gap-sm) 0;
							border-top: 1px solid var(--lo-color-border-default);

							dt {
								color: var(--lo-color-text-secondary);
							}

							dd {
								margin: 0;
								text-align: right;
							}
						}
					}
				}
			}
		`
	]
})
export class PlanDetailsDialogComponent {
	constructor(
		private dialogRef: LoDialogRef<PlanDetailsDialogComponent>,
		@Inject(LO_DIALOG_DATA) public data: PlanDetailsDialogData
	) {}

	close(): void {
		this.dialogRef.close();
	}
}
